import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import Super from '../-resources';

export default class SiteBillingInsuranceNew extends Super {
  @tracked isSubmitted = false;

  @action
  setSubmitted() {
    this.isSubmitted = true;
  }
}
